/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const PreferencesIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7142 5.14282L21.4285 5.14282"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.57141 5.14282L5.14284 5.14282"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M20.5714 12H21.4286"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.57141 12L12 12"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M13.7142 18.8572L21.4285 18.8572"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.57141 18.8572H5.14284"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M7.71425 7.71439C9.13441 7.71439 10.2857 6.56312 10.2857 5.14296C10.2857 3.7228 9.13441 2.57153 7.71425 2.57153C6.29409 2.57153 5.14282 3.7228 5.14282 5.14296C5.14282 6.56312 6.29409 7.71439 7.71425 7.71439Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M14.5714 14.5713C15.9916 14.5713 17.1429 13.4201 17.1429 11.9999C17.1429 10.5797 15.9916 9.42847 14.5714 9.42847C13.1513 9.42847 12 10.5797 12 11.9999C12 13.4201 13.1513 14.5713 14.5714 14.5713Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M7.71425 21.4285C9.13441 21.4285 10.2857 20.2772 10.2857 18.8571C10.2857 17.4369 9.13441 16.2856 7.71425 16.2856C6.29409 16.2856 5.14282 17.4369 5.14282 18.8571C5.14282 20.2772 6.29409 21.4285 7.71425 21.4285Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
